import { LitElement, css, html, nothing } from '@lit'
import styles from '@nova/styles'
import { formatPrice, t } from '@nova/utils'
import * as paths from '@nova/paths'

class NovaFreeShippingThreshold extends LitElement {
  static properties = {
    cartSubtotal: {
      type: Number,
      attribute: 'cart-subtotal'
    },
  }

  get percentageValue() {
    return (this.cartSubtotal / this.threshold) * 100
  }

  constructor() {
    super()
    document.addEventListener(
      'nova:changeQuantityFinished',
      this._handleUpdateProgressBar,
    )
    this.threshold = __NOVA_GLOBAL__.freeShippingThreshold
    this.calculated = false
  }

  _calculateRemaining() {
    return formatPrice((this.threshold - this.cartSubtotal) * 100)
  }

  _interpolateTemplate(template, replacements) {
    return template.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, placeholder) => {
      return replacements[placeholder] || match
    })
  }

  _displayMessage() {
    let message
    if(typeof this.cartSubtotal === 'undefined') return ''

    if (this.cartSubtotal >= this.threshold) {
      message = html`${paths.cartFreeCheck}<span>${t('sections.cart.free_shipping_threshold.congratulations')}</span>`;
    } else {
      const translationTemplate = t('sections.cart.free_shipping_threshold.message');
      const remaining = this._calculateRemaining();
      message = this._interpolateTemplate(translationTemplate, { remaining });
    }
    this.calculated = true
    return message
  }

  render() {
    return html`
      <div class="wrapper">
        <p>${this._displayMessage()}</p>
        ${this.calculated ? html`<sl-progress-bar value=${this.percentageValue}></sl-progress-bar>`: nothing}
      </div>
    `
  }

  static styles = [
    styles.flex,
    css`
      :host {
        display: block;
        background: var(--nova-color-white);
        border-bottom: 1px solid var(--nova-color-grey-200);
        height: 92px;
        display: flex;
        align-items: center;
      }

      .wrapper {
        display: flex;
        flex-direction: column;
        gap: var(--nova-space-xs);
        padding: var(--nova-space-md);
        width: 100%;

        @media screen and (min-width: 1024px) {
          padding: var(--nova-space-sm);
        }
      }

      p {
        font: var(--nova-body-font);
        margin: 0;
        color: var(--nova-color-charcoal);
        display: flex;
        gap: var(--nova-space-xs);
      }

      sl-progress-bar {
        --height: 3px;
        --indicator-color: var(--nova-color-free-shipping-progress-bar);
      }
    `,
  ]
}

customElements.define('nova-free-shipping-threshold', NovaFreeShippingThreshold)
